import { ApiResponse, getData } from './Apis';

export type YourApplicationContainerModel = {
    Features: YourApplicationsFeaturesModel,
    Applications: YourApplicationModel[],
}

export type YourApplicationsFeaturesModel = {
    JobBoard_PracticeGroup: boolean,
}

export type YourApplicationModel = {
    ApplicationNumber: number,
    Completed: boolean,
    positionTitle: string,
    applyingforid: number,
    closingdate?: Date,
    PositionStatus: string,
    ExternalDepartment: string,
    PracticeGroup: string,
    LocationText: string,
    PositionType: string,
    PositionVisible?: boolean,
    CanApplyIfForwarded: boolean,
}

export async function API_YourApplications(token:string): Promise<ApiResponse<YourApplicationContainerModel>> {
    return await getData<ApiResponse<YourApplicationContainerModel>>(`webapi/candidate/yourapplications/GetAll?token=${token}`);
}
